import React from "react";
import servicesOpportunity from "assets/services-image/services_opportunity.png";

const Opportunity = () => {
  return (<div className="services-section mobile-reverse--image">
    <div className="services-section--image">
      <img src={servicesOpportunity} alt="Opportunity"/>
    </div>
    <div className="services-section--content">
      <h2>Opportunity</h2>
      <ul>
        <li>
          <p><b>Opportunity Tracking:</b> Manage potential deals and track their progress.</p>
        </li>
        <li>
          <p><b>Stage Management:</b> Define and manage different stages of opportunity.</p>
        </li>
        <li>
          <p><b>Revenue Forecasting:</b> Predict potential revenue from opportunity.</p>
        </li>
        <li>
          <p><b>Competitor Analysis:</b> Track and analyze competitors involved in opportunity.</p>
        </li>
        <li>
          <p><b>Win/Loss Analysis:</b> Analyze reasons for winning or losing opportunity.</p>
        </li>
      </ul>
    </div>
  </div>);
};

export default Opportunity;
